// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.SearchProcessBar.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import GridLayout from 'share/components/controls/Izenda.GridLayout';
import Loading from 'share/components/controls/Izenda.Loading';

export default connect()(function EmailProgressBar(props: any) {
  const { localization } = props;
  const promiseFunction = props.promiseFunction;

  const onCancelHandler = () => {
    props.setLoadingPromise(null);
    promiseFunction.cancel();
  };

  return (
    promiseFunction &&
    promiseFunction.isPending() && (
      <GridLayout>
        <GridLayout.Row>
          <GridLayout.Col cols={2}>
            <strong className="u_inlineBlock u_paddingAll">{localization.getText('EMAIL_LABEL_SENDING')}</strong>
          </GridLayout.Col>
          <GridLayout.Col cols={8} className="u_controlHeight u_paddingAll">
            <Loading show withoutBorder />
          </GridLayout.Col>
          <GridLayout.Col cols={2} onClick={onCancelHandler}>
            <a className="u_paddingAll u_inlineBlock u_textLink">{localization.getText('COMMON_LABEL_CANCEL')}</a>
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout>
    )
  );
});



// WEBPACK FOOTER //
// ./ui/share/components/controls/CommonPopup/Izenda.EmailProgressBar.js